import { statusFormLabels } from "@/constants/tutorials";
import { Tutorial } from "@/types";
import { stringToColor } from "@/utils/names";
import { Clock01Icon } from "@hugeicons/core-free-icons";
import { HugeiconsIcon } from "@hugeicons/react";
import { Avatar, Chip, Stack, Typography } from "@mui/material";
import { formatDistanceToNow } from "date-fns";
import { es } from "date-fns/locale";

interface SuggestionCardProps {
    suggestion: Partial<Tutorial>;
    userName?: string;
    businessName?: string;
    initials?: string;
}

const SuggestionCard = ({ suggestion, userName, businessName, initials }: SuggestionCardProps) => {

    const statusInfo = statusFormLabels.find(
        (status) => status[0] === suggestion.status
    );


    return (
        <Stack
            sx={{
                border: "1px solid",
                borderColor: "divider",
                borderRadius: 3,
                p: 2,
            }}
            spacing={1.5}
        >
            <Stack direction={"row"} justifyContent={"space-between"} alignItems={"center"}>
                <Chip
                    label={statusInfo?.[1]}
                    size="small"
                    color={statusInfo?.[2]}
                />
                <Typography
                    variant="caption"
                    sx={{
                        alignItems: "center",
                        justifyContent: "center",
                        display: "flex",
                        gap: 0.5
                    }} color="text.secondary"
                >
                    {<HugeiconsIcon icon={Clock01Icon} size={18} />}
                    {formatDistanceToNow(new Date(suggestion?.createdAt ? suggestion.createdAt : ""), { addSuffix: true, locale: es })}
                </Typography>
            </Stack>

            <Typography variant="h4">
                {suggestion.title}
            </Typography>

            <Typography
                variant="body2"
                color="text.secondary"
            >
                {suggestion.message}
            </Typography>

            <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
            >
                <Stack direction="row" spacing={1} alignItems="center">
                    <Avatar
                        sx={{
                            bgcolor: stringToColor(initials ?? ""),
                            color: "white",
                            fontSize: "0.95rem",
                            width: 36,
                            height: 36,
                        }}
                    >
                        {initials}
                    </Avatar>

                    <Stack>
                        <Typography variant="caption" fontWeight={600}>
                            {userName}
                        </Typography>

                        <Typography variant="caption">
                            {businessName}
                        </Typography>
                    </Stack>
                </Stack>
            </Stack>
        </Stack>

    )
};

export default SuggestionCard;